import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { openPopup } from '@appbase/util/popup-helper' 
import { IEDate } from '@appbase/util/date-helper';
import IFrameModal from '@appbase/components/modal/IFrameModal.vue';
import { invalidateUrl } from '@appbase/util';

@Component({})
export default class GnbSearch extends Vue {
    @Prop({type:Array}) orgList!: orgmap.UserItem[]
    @Prop({type:Array}) articleList!: gnbarticle.Article[]
    @Prop({type:Number}) articleCount!: number
    @Prop({type:String}) userLang!: string
    @Prop({type:Boolean}) useSearchSystem!: boolean
    
    // 사용자 전사검색
    allCompany:boolean = false
    
    fnDisplayDate(date: string){
        let dtDate = IEDate(date);
        return dtDate.toISOString().slice(0, 10);
    }

    fnVieArticle(articleId: number, boardId: number, boardName: string, title:string){
        if(this.isTeams){
            const modal: appbase.IModalOpenable = this.$refs['modal'] as any
            const options: appbase.TModalInfo<any> = {
                component: IFrameModal,
                props: { 
                    title: boardName, 
                    src: invalidateUrl(`/BoardPopup/readPopup?SYSID=${boardId}&ARTICLEID=${articleId}`),
                    noHeader: true,
                    noFooter: true,
                    mStyle: 'width: 1280px; height: 700px; padding:0'         
                 }
            };

            modal.openModal(options)
        } else {
            openPopup('', `/BoardPopup/readPopup?SYSID=${boardId}&ARTICLEID=${articleId}`, {}, {
                width: 1024,
                height: 700,
            });
        }       
    }
}